export const simpleAction = (type: string) => ({
  type,
});
